import React from 'react';
import Icon from '../../../components/AppIcon';

const ProcessingStages = ({ currentStage, progress }) => {
  const stages = [
    {
      id: 'validation',
      label: 'Validação',
      description: 'Verificando estrutura do arquivo',
      icon: 'FileCheck'
    },
    {
      id: 'normalization',
      label: 'Normalização',
      description: 'Convertendo formatos de dados',
      icon: 'RefreshCw'
    },
    {
      id: 'mapping',
      label: 'Mapeamento',
      description: 'Detectando colunas automaticamente',
      icon: 'Map'
    },
    {
      id: 'ai-analysis',
      label: 'Análise IA',
      description: 'Processando variações e kits',
      icon: 'Sparkles'
    },
    {
      id: 'completion',
      label: 'Finalização',
      description: 'Preparando catálogo',
      icon: 'CheckCircle2'
    }
  ];

  const getCurrentStageIndex = () => {
    return stages?.findIndex(stage => stage?.id === currentStage);
  };

  const currentIndex = getCurrentStageIndex();

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between mb-2">
        <h4 className="font-medium text-foreground">Progresso do Processamento</h4>
        <span className="caption text-muted-foreground data-text">{progress}%</span>
      </div>
      <div className="w-full h-2 bg-muted rounded-full overflow-hidden mb-6">
        <div 
          className="h-full bg-primary transition-smooth"
          style={{ width: `${progress}%` }}
        />
      </div>
      <div className="hidden lg:grid lg:grid-cols-5 gap-4">
        {stages?.map((stage, index) => {
          const isActive = index === currentIndex;
          const isCompleted = index < currentIndex;
          const isPending = index > currentIndex;

          return (
            <div
              key={stage?.id}
              className={`
                relative p-4 rounded-lg border transition-smooth
                ${isActive ? 'border-primary bg-primary/5' : ''}
                ${isCompleted ? 'border-success/30 bg-success/5' : ''}
                ${isPending ? 'border-border bg-muted/30' : ''}
              `}
            >
              <div className="flex flex-col items-center text-center gap-3">
                <div className={`
                  flex items-center justify-center w-12 h-12 rounded-full transition-smooth
                  ${isActive ? 'bg-primary/20' : ''}
                  ${isCompleted ? 'bg-success/20' : ''}
                  ${isPending ? 'bg-muted' : ''}
                `}>
                  <Icon
                    name={isCompleted ? 'Check' : stage?.icon}
                    size={20}
                    color={
                      isActive ? 'var(--color-primary)' :
                      isCompleted ? 'var(--color-success)': 'var(--color-muted-foreground)'
                    }
                    className={isActive ? 'animate-pulse' : ''}
                  />
                </div>

                <div>
                  <p className={`
                    caption font-medium mb-1
                    ${isActive ? 'text-primary' : ''}
                    ${isCompleted ? 'text-success' : ''}
                    ${isPending ? 'text-muted-foreground' : ''}
                  `}>
                    {stage?.label}
                  </p>
                  <p className="caption text-muted-foreground text-xs">
                    {stage?.description}
                  </p>
                </div>
              </div>
              {index < stages?.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-2 w-4 h-0.5 bg-border -translate-y-1/2" />
              )}
            </div>
          );
        })}
      </div>
      <div className="lg:hidden space-y-3">
        {stages?.map((stage, index) => {
          const isActive = index === currentIndex;
          const isCompleted = index < currentIndex;
          const isPending = index > currentIndex;

          return (
            <div
              key={stage?.id}
              className={`
                flex items-center gap-4 p-3 rounded-lg border transition-smooth
                ${isActive ? 'border-primary bg-primary/5' : ''}
                ${isCompleted ? 'border-success/30 bg-success/5' : ''}
                ${isPending ? 'border-border bg-muted/30' : ''}
              `}
            >
              <div className={`
                flex items-center justify-center w-10 h-10 rounded-full flex-shrink-0 transition-smooth
                ${isActive ? 'bg-primary/20' : ''}
                ${isCompleted ? 'bg-success/20' : ''}
                ${isPending ? 'bg-muted' : ''}
              `}>
                <Icon
                  name={isCompleted ? 'Check' : stage?.icon}
                  size={18}
                  color={
                    isActive ? 'var(--color-primary)' :
                    isCompleted ? 'var(--color-success)': 'var(--color-muted-foreground)'
                  }
                  className={isActive ? 'animate-pulse' : ''}
                />
              </div>
              <div className="flex-1 min-w-0">
                <p className={`
                  caption font-medium mb-0.5
                  ${isActive ? 'text-primary' : ''}
                  ${isCompleted ? 'text-success' : ''}
                  ${isPending ? 'text-muted-foreground' : ''}
                `}>
                  {stage?.label}
                </p>
                <p className="caption text-muted-foreground text-xs truncate">
                  {stage?.description}
                </p>
              </div>
              {isActive && (
                <Icon name="Loader2" size={18} className="text-primary animate-spin flex-shrink-0" />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProcessingStages;